import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import { Alignment, EmailInput, Icon, TextArea, TextInput } from 'tacho-ui';
import { ApplicationState } from '../../../state/ApplicationState';
import { DispatchType } from '../../../state/configureStore';
import { TachoModal } from '../../components/TachoModal';
import { TachoEditModalTitle } from '../../components/TachoModal/TachoEditTitle';
import { AddDistributor, defaultAddDistributor } from '../../../core/domainModels/distributors/AddDistributor';
import { addDistributorThunk, fetchDistributorsThunk } from '../../../state/distributors/reducer';
interface AddDistributorModalProps {
    isOpen: boolean;
    onToggle: () => void;
}
export const AddDistributorModal = (props: AddDistributorModalProps) => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch<DispatchType>();
    const [distributorData, setDistributorData] = useState<AddDistributor>(defaultAddDistributor);
    const onSubmit = () => {
        dispatch(addDistributorThunk(distributorData))
            .unwrap()
            .then(success => {
                if (success) {
                    dispatch(fetchDistributorsThunk());
                    setDistributorData(defaultAddDistributor);
                    props.onToggle();
                }
            })
            .catch(err => console.log(err));
    };
    const addDistributorPending = useSelector((state: ApplicationState) => state.distributors.addDistributorPending);
    const addDistributorError = useSelector((state: ApplicationState) => state.distributors.addDistributorError);

    return (
        <TachoModal
            size={'lg'}
            height={'auto'}
            isOpen={props.isOpen}
            onToggle={() => {
                setDistributorData(defaultAddDistributor);
                props.onToggle();
            }}
            onSubmit={onSubmit}
            title={<TachoEditModalTitle titleToTranslation="distributorAddDistributor" icon={Icon.User} />}
            submitLabelToTranslate="commonAdd"
            submitIcon={Icon.Add}
            isPending={addDistributorPending}
            errorToTranslate={addDistributorError}
            disableSubmitButton={!distributorData.name}
        >
            <Container fluid className="d-flex flex-column px-4 gap-3">
                <Row>
                    <Col className="d-flex flex-column gap-2">
                        <TextInput
                            labelLength={1}
                            inputLength={3}
                            label={formatMessage({ id: 'distributorName' })}
                            value={distributorData?.name}
                            onChange={value => setDistributorData({ ...distributorData, name: value })}
                        />
                        <EmailInput
                            labelLength={1}
                            inputLength={3}
                            label={formatMessage({ id: 'distributorEmail' })}
                            value={distributorData?.email}
                            onChange={value => setDistributorData({ ...distributorData, email: value })}
                        />
                    </Col>
                </Row>
                <Row>
                    <TextArea
                        labelLength={-1}
                        label={formatMessage({ id: 'distributorNotes' })}
                        align={Alignment.flexStart}
                        value={distributorData.notes}
                        onChange={value => setDistributorData({ ...distributorData, notes: value as string })}
                    />
                </Row>
            </Container>
        </TachoModal>
    );
};
